import { SKILL_INFO } from './workflowShared';

interface SkillInfoModalProps {
  isOpen: boolean;
  availableSkills: string[];
  onClose: () => void;
}

function ModalCloseButton({ onClose, disabled = false }: { onClose: () => void; disabled?: boolean }) {
  return (
    <button
      className="modal-close"
      type="button"
      onClick={onClose}
      disabled={disabled}
      aria-label="Close modal"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
  );
}

function SkillInfoModal({ isOpen, availableSkills, onClose }: SkillInfoModalProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(event) => event.stopPropagation()}>
        <div className="modal-header">
          <h2>About Skills</h2>
          <ModalCloseButton onClose={onClose} />
        </div>

        <div className="modal-body">
          <div className="skill-info-notice">
            <p>
              Note: All skills are taken from their respective repositories without modification.
              These skills are maintained by their original authors and used as provided.
            </p>
          </div>

          <div className="skill-info-list">
            {availableSkills.map((skillKey) => {
              const info = SKILL_INFO[skillKey];

              if (!info) {
                return null;
              }

              return (
                <div key={skillKey} className="skill-info-item">
                  <h3>{info.title}</h3>
                  <p>{info.description}</p>
                  <a
                    href={info.githubUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="skill-github-link"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                    </svg>
                    View on GitHub
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export { ModalCloseButton };
export default SkillInfoModal;
